import CharacterSetECI from '../common/CharacterSetECI';
/**
 * Just to make a shortcut between Java code and TS code.
 */
var StandardCharsets = /** @class */ (function () {
    function StandardCharsets() {
    }
    StandardCharsets.ISO_8859_1 = CharacterSetECI.ISO8859_1;
    return StandardCharsets;
}());
export default StandardCharsets;
//# sourceMappingURL=StandardCharsets.js.map